import { render, staticRenderFns } from "./ButtonCarouselRight.vue?vue&type=template&id=35c2a43c"
import script from "./ButtonCarouselRight.vue?vue&type=script&lang=js"
export * from "./ButtonCarouselRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports